import axios from 'axios'
import DataContact from './../data/general/contact'
import DataForms from './../data/main/config/setup/form/forms'
import DataMaterials from './../data/main/config/setup/material/materials'
import DataRand from './../data/main/config/setup/rand/randArt'
import DataShipping from './../data/main/config/shippingCosts'

class DataService {
  static getForms () {
    return new Promise((resolve, reject) => {
      axios.get('api/forms')
        .then(res => {
          const forms = DataForms.forms
          for (const form of Object.values(forms)) {
            form.type.forEach(form => { form.factor = res.data[form.code].factor })
          }
          resolve(forms)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  static getMaterials () {
    return new Promise((resolve, reject) => {
      axios.get('api/materials')
        .then(res => {
          const materials = DataMaterials.materials
          for (const [material, attr] of Object.entries(materials)) {
            materials[material].price = res.data[attr.code].price
            materials[material].delivery = res.data[attr.code].delivery
          }
          resolve(materials)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  static getRand () {
    return new Promise((resolve, reject) => {
      axios.get('api/rand')
        .then(res => {
          const randArt = DataRand.randArt
          const saum = randArt.saum
          saum.price = res.data[saum.titleSaum.code].price
          const oesen = randArt.saum.optionsOesenart
          oesen[0].value.price = res.data[oesen[0].value.code].price
          oesen[0].text = res.data[oesen[0].value.code].type
          for (const [art, attr] of Object.entries(oesen[1].options)) {
            oesen[1].options[art].value.price = res.data[attr.value.code].price
            oesen[1].options[art].text = res.data[attr.value.code].type
          }
          for (const [art, attr] of Object.entries(oesen[2].options)) {
            oesen[2].options[art].value.price = res.data[attr.value.code].price
            oesen[2].options[art].text = res.data[attr.value.code].type
          }
          const drehverschluss = randArt.saum.optionsDrehverschluss
          drehverschluss[0].value.factor = res.data[drehverschluss[0].value.code].price
          drehverschluss[1].value.factor = res.data[drehverschluss[1].value.code].price
          const hohlsaum = randArt.hohlsaum.optionsBreiteHohlsaum
          for (const [breite, attr] of Object.entries(hohlsaum)) {
            hohlsaum[breite].value.price = res.data[attr.value.code].price
            hohlsaum[breite].text = res.data[attr.value.code].type
          }
          const keder = randArt.keder.optionsKederGroesse
          for (const [art, attr] of Object.entries(keder)) {
            keder[art].value.price = res.data[attr.value.code].price
            keder[art].text = res.data[attr.value.code].type
          }
          const hohlschnitt = randArt.hohlschnitt
          hohlschnitt.factor = res.data[hohlschnitt.title.code].price
          resolve(randArt)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  static getShipping () {
    return new Promise((resolve, reject) => {
      axios.get('api/shipping')
        .then(res => {
          const shippingCosts = DataShipping.shippingCosts
          const germany = shippingCosts.country.germany.types
          for (const [type, attr] of Object.entries(germany)) {
            germany[type].price = res.data[attr.code].price
          }
          const eu = shippingCosts.country.eu.types
          for (const [type, attr] of Object.entries(eu)) {
            eu[type].price = res.data[attr.code].price
          }
          resolve(shippingCosts)
        })
        .catch(err => {
          DataShipping.shippingCosts.loadingError = true
          reject(err)
        })
    })
  }

  static getBasics () {
    return new Promise((resolve, reject) => {
      axios.get('api/basics')
        .then(res => {
          const basics = res.data
          resolve(basics)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  static getIslands () {
    return new Promise((resolve, reject) => {
      axios.get('api/islands')
        .then(res => {
          const islands = res.data
          resolve(islands)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  static getContact () {
    return new Promise((resolve, reject) => {
      axios.get('api/contact')
        .then(res => {
          const contact = DataContact.contact
          for (const attr in contact) {
            contact[attr].content = res.data.C01[attr]
          }
          resolve(contact)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  static getInitialValues () {
    return new Promise((resolve, reject) => {
      axios.get('api/initial')
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
};

export default DataService
